
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 32 29\" id=\"icon-star-trustpilot\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g id=\"icon-star-trustpilot_Shape_1_copy_4\"> <g> <path d=\"M15.9,22.2l6.5-1.7l2.7,8.6L15.9,22.2z M30.9,11.1H19.5L15.9,0l-3.5,11.1H1l9.2,6.8L6.7,29l9.2-6.8l5.7-4.2\r\n\tL30.9,11.1z\"/> </g> </g> </symbol>";
module.exports = sprite.add(image, "icon-star-trustpilot");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/star-trustpilot.svg
 ** module id = 228
 ** module chunks = 24
 **/